import styled from '@emotion/styled';
import { GridCol } from '@naf/grid';
import { breakpoints } from '@naf/theme';
import { NavCard } from '../simba-cards';

export const StyledCardNavigation = styled(NavCard)`
  width: 100%;
  height: 100%;

  @media (max-width: ${breakpoints.xl}) {
    width: -webkit-fill-available;
    width: fill-available;
  }
`;

export const ShortCutCol = styled(GridCol)`
  display: flex;

  /* The Simba card sizes to its content, so let it fill the grid cell. */
  > * {
    display: flex;
    flex: 1;
  }

  a {
    margin-bottom: 0;
  }
`;
